<template>
  <div class="match">
    <div class="match__thead">
      <div class="match__thead__name">比赛名称</div>
      <div class="match__thead__format">赛制</div>
      <div class="match__thead__timer">比赛时间</div>
      <div class="match__thead__pattern">比赛模式</div>
      <div class="match__thead__state">比赛状态</div>
      <div class="match__thead__come">比赛入口</div>
    </div>
    <div class="match__content">
      <template v-for="(item,index ) in tableList">
        <div
          :key="index"
          class="match__content___item"
        >
          <div class="match__content___item-name" @click="handleClick(item)">
            <span class="match__content___item-name-text">{{ item.name }}</span>
          </div>
          <div class="match__content___item-format">
            {{ item.type === 0 ? '普通':'OI' }}
          </div>
          <div class="match__content___item-timer">
            {{ item.startTime | formatTimer }} - {{ item.endTime | formatTimer }}
          </div>
          <div class="match__content___item-pattern">
            {{ item.mode === 0 ? '固定时间':`任选连续${item.duration}分钟` }}
          </div>
          <div
            class="match__content___item-tag"
            :style="getTagStyle(item)"
          >
            {{ Boolean(item.status) ? '进行中': '已结束' }}
          </div>
          <div
            class="match__content___item-button"
            :style="getBtnStyle(item)"
            @click="handleClick(item)"
          >
            {{ Boolean(item.status) ? '点击进入': '比赛回顾' }}
          </div>
        </div>
      </template>
    </div>
    <div class="pagination">
       <el-pagination
          @current-change="pageChange"
          background
          :pager-count="11"
          value-format="timestamp"
          :current-page="screenForm.pageNum"
          :page-size="screenForm.pageSize"
          layout="prev, pager, next"
          :total="total">
        </el-pagination>
    </div>
  </div>
</template>

<script>
import { parseTime } from '@/utils/format.js';
export default {
  props:{
    list:{
      type:Array,
      default:()=>{}
    },
    form:{
      type:Object,
      default:()=>{}
    },
    total:{
      type:Number,
      default:0
    }
  },
  filters:{
    formatTimer(val){
      return parseTime(val,'{m}月{d}日{h}:{i}')
    }
  },
  data(){
    return{
      tableList:this.list,
      screenForm:this.form
    }
  },
  watch:{
    list(newVal) {
      this.tableList = newVal;
    },
    form: {
      handler(newVal) {
        this.screenForm = newVal;
      },
      deep: true,
    },
  },
  methods: {
    pageChange(page) {
      this.screenForm.pageNum = page;
      this.$emit('onChange', this.screenForm);
    },
    handleClick(item) {
      this.$emit('handleGoClick', item);
    },
    getTagStyle(item) {
      return item.status ? { color: '#68953C' } : { color: '#666666' };
    },
    getBtnStyle(item) {
      return item.status
        ? {
          background: '#FBC01F',
          border: '1px solid #DEA200',
          color: '#333',
        }
        : {
          background: '#FFF7E7',
          border: '1px solid #F9E3B9',
          color: '#333',
        };
    },
  },
}
</script>

<style lang="less" scoped>
.match {
  width: 1100px;
  min-height: 600px;
  margin: 24px auto 0;
  position: relative;
  box-shadow: 0px 0px 8px 0px rgba(64, 64, 64, 0.2);
  border-radius: 8px;
  background: #fff;
  padding-bottom: 100px;
  &__thead{
    display: flex;
    align-items: center;
    text-align: center;
    height:56px;
    color:#333;
    font-size: 18px;
    background: #FFFCF2;
    border-bottom:1px solid #EDEDED;
    font-family: PingFangSC-Regular, PingFang SC;
    &__name {
      width: 20%;
    }
    &__format {
      width: 6%;
    }
    &__timer {
      width: 26%;
    }
    &__pattern {
      width: 16%;
    }
    &__state {
      width: 8%;
    }
    &__come{
      width: 20%;
    }
  }
  &__content {
    width: 100%;
    &___item {
      width: 100%;
      border-bottom: 1px solid rgba(242, 242, 242, 1);
      height: 62px;
      line-height: 62px;
      font-size: 16px;
      font-weight: 400;
      color: rgba(0, 0, 0, 1);
      text-align: left;
      position: relative;
      display: flex;
      align-items: center;
      text-align: center;
      &-name {
        width: 20%;
        text-align: center;
        color:#333;
        font-weight: 500;
        font-family: PingFangSC-Medium, PingFang SC;
        &-text{
          display: block;
          width: 80%;
          margin:0 auto;
          text-align: center;
          cursor: pointer;
          overflow: hidden;/*超出部分隐藏*/
          text-overflow:ellipsis;/* 超出部分显示省略号 */
          white-space: nowrap;/*规定段落中的文本不进行换行 */
          &:hover{
            color:#EBAC00;
          }
        }
      }
      &-format {
        width: 6%;
      }
       &-timer {
        width: 26%;
      }
       &-pattern {
        width: 16%;
      }
      &-tag {
        width: 8%;
      }
      &-button {
        width:102px;
        height:30px;
        cursor: pointer;
        border-radius:16px;
        position: absolute;
        right: 100px;
        top: 16px;
        font-size:14px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(253,247,226,1);
        line-height:28px;
        text-align: center;
      }
    }
  }
  .pagination{
    position: absolute;
    bottom: 30px;
    left:50%;
    transform: translate(-50%,0);
    /deep/ .el-pagination.is-background .el-pager li:not(.disabled){
      background-color: #fff;
      border:1px solid #D3D3D3;
      color:#333333;
      font-weight: 400;
      font-size: 14px;
      border-radius:4px;
      &:hover{
        color:#333333
      }
    }
    /deep/ .el-pagination button{
      background: #fff;
      border:1px solid #D3D3D3;
    }
    /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: #FBC01F;
      color: #333333;
      border:none;
      font-weight: 500;
      border:1px solid #FBC01F;
      
    }
    /deep/ .el-pagination.is-background
    .btn-next, .el-pagination.is-background
    .btn-prev, .el-pagination.is-background .el-pager li{
      background: #fff;
      border:1px solid #D3D3D3;
    }

  }
}
</style>
